import axios from 'axios'; // 引入axios
// import QS from 'qs'; // 引入qs模块，用来序列化post类型的数据，后面会提到
// vant的toast提示框组件，大家可根据自己的ui组件更改。
import store from '../store.js';
import { Toast } from 'vant';
import { reportClientIssue } from '../utils/clientDiagnostics';

function reportNetworkFailure(error) {
  try {
    const response = error && error.response;
    const config = error && error.config;
    if (response && response.status < 500) return;
    reportClientIssue({
      kind: 'network',
      message: response ? 'HTTP server error' : 'Network request failed or timed out',
      context: {
        endpoint: config && config.url,
        method: config && config.method,
        status: response && response.status,
        errorCode: error && error.code
      }
    });
  } catch (ignored) {}
}

let base = '';
console.log(process.env.NODE_ENV);
// 环境的切换 https://stg-study.51i.cc/api/wiki
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'https://stg-study.51i.cc';
} else if (process.env.NODE_ENV === 'debug') {
  axios.defaults.baseURL = 'https://stg-study.51i.cc';
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'https://study.51i.cc';
}
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json';

// 请求延时post
axios.defaults.timeout = 15000;

axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // var openid = "xx";
    var openid = localStorage.getItem('openid');
    if (config.method === 'post') {
      // 如果data是数组，不要添加Openid（保持原始数组格式）
      if (!Array.isArray(config.data)) {
        config.data = {
          Openid: openid,
          ...config.data
        };
      }
    } else if (config.method === 'get') {
      config.params = {
        Openid: openid,
        ...config.params
      };
    }
    const token = store.state.token || localStorage.getItem('token');
    // console.log(this.$store);
    // console.log(this.store);
    token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    reportNetworkFailure(error);
    return Promise.reject(error);
  }
);

// http response 拦截器

axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log(error);
    reportNetworkFailure(error);
    if (!error || !error.response) return Promise.reject(error);
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          //   router.replace({
          //     path: '/login',
          //     query: { redirect: router.currentRoute.fullPath }
          //   })
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          Toast({
            message: '登录过期，请重新登录',
            duration: 1000,
            forbidClick: true
          });
          // 清除token
          localStorage.removeItem('token');
          // store.commit("loginSuccess", null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            this.$router.push({
              path: '/'
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
        case 415:
          Toast({
            message: '网络请求不存在',
            duration: 1500,
            forbidClick: true
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          Toast({
            message: error.response.data.message,
            duration: 1500,
            forbidClick: true
          });
      }
      return Promise.reject(error.response);
    }
  }
);

export const BaseApiUrl = base;

// 请求样例
// export const getUserListPage = (params) => {
//   return axios.get(`${base}/api/user/get`, { params: params });
// };
// export const removeUser = (params) => {
//   return axios.delete(`${base}/api/user/delete`, { params: params });
// };
// export const editUser = (params) => {
//   return axios.put(`${base}/api/user/put`, params);
// };
// export const addUser = (params) => {
//   return axios.post(`${base}/api/user/post`, params);
// };
// ecp登录注册发送短信
export const Member_send_message = params => {
  return axios.post(`${base}/api/WeChatMember/send_message`, params);
};

// 添加用户
export const Member_AddMember = params => {
  return axios.post(`${base}/api/WeChatMember/AddMember`, params);
};

// 短信验证码校验
export const Member_CheckMessage = params => {
  return axios.post(`${base}/api/WeChatMember/CheckMessage`, params);
};

// 已注册消费者通过openid查询个人信息
export const Member_QueryMember = params => {
  return axios.post(`${base}/api/WeChatMember/QueryMember`, params);
};

// 首页课程列表
export const Curriculum_GetCurricula = params => {
  return axios.post(`${base}/api/WeChatCurriculum/GetCurricula`, params);
};

// 通过openid获取用户拥有的证书
export const Certificate_GetCertificateByOpenId = params => {
  return axios.post(`${base}/api/WeChatCertificate/GetCertificateByOpenId`, params);
};

// 获取所有可获得的证书（包括已获得和未获得，用于证书收集页面）
export const Certificate_GetAllCertificatesForCollection = params => {
  return axios.post(`${base}/api/WeChatCertificate/GetAllCertificatesForCollection`, params);
};

// 提交证书申请（RuleType=2 申请审核流程）
export const CertificateApply_Submit = params => {
  return axios.post(`${base}/api/WeChatCertificateApply/Submit`, params);
};

// 查询我的证书申请记录列表
export const CertificateApply_GetMyApplyList = params => {
  return axios.get(`${base}/api/WeChatCertificateApply/GetMyApplyList`, {
    params: params
  });
};

// 获取课程上下级菜单
export const WeChatCurriculum_GetCurricularGroup = params => {
  return axios.post(`${base}/api/WeChatCurriculum/GetCurricularGroup`, params);
};

// 获取所有分类及课程（含解锁状态）- 首页聚合接口
export const WeChatCurriculum_GetAllCurriculaWithUnlockStatus = (openId) => {
  return axios.get(`${base}/api/WeChatCurriculum/GetAllCurriculaWithUnlockStatus`, {
    params: { OpenId: openId }
  });
};

// 通过菜单Id获取课程列表
export const WeChatCurriculum_GetCurriculaByGroupId = params => {
  return axios.post(`${base}/api/WeChatCurriculum/GetCurriculaByGroupId`, params);
};

// 通过课程Id查看课程详情
export const WeChatCurriculum_GetCurriculaById = params => {
  return axios.get(`${base}/api/WeChatCurriculum/GetCurriculaById`, {
    params: params
  });
};

// 根据课程Id获取评论列表
export const WeChatEvaluation_GetEvaluationList = params => {
  return axios.get(`${base}/api/WeChatEvaluation/GetEvaluationList`, {
    params: params
  });
};

// 考试列表
export const WeChatMemberExam_MemberExamList = params => {
  return axios.post(`${base}/api/WeChatMemberExam/MemberExamList`, params);
};

// 用户答题
export const WeChatMemberExam_MemberAnswerPost = params => {
  return axios.post(`${base}/api/WeChatMemberExam/MemberAnswerPost`, params, { timeout: 120000 });
};

// 用户答题列表
export const WeChatMemberExam_GetMemberExamTopicList = params => {
  return axios.post(`${base}/api/WeChatMemberExam/GetMemberExamTopicList`, params);
};

// 用户评论
export const WeChatEvaluation_MemberEvaluation = params => {
  return axios.post(`${base}/api/WeChatEvaluation/MemberEvaluation`, params);
};

// 修改个人信息
export const WeChatMember_UptMember = params => {
  return axios.post(`${base}/api/WeChatMember/UptMember`, params);
};

// 标记已查看平台指引
export const WeChatMember_MarkGuideViewed = (openId) => {
  return axios.post(`${base}/api/WeChatMember/MarkGuideViewed?openId=${openId}`);
};

// /api/WeChatMember/GetH5LoginJwtToken/JWTToken3.0 获取JWT的方法3：公众号登录token
export const GetH5LoginJwtToken_JWTToken3 = params => {
  return axios.get(`${base}/api/WeChatMember/GetH5LoginJwtToken/JWTToken3.0`, {
    params: params
  });
};

// 根据用户openid获取用户培训列表
export const WeChatMemberCultivate_GetMemberCultivateList = params => {
  return axios.get(`${base}/api/WeChatMemberCultivate/GetMemberCultivateList`, {
    params: params
  });
};

// 新增用户培训（保存记录
export const CCMWaabeeeehilmrtttuv_SaveMemberCultivate = params => {
  return axios.post(`${base}/api/WeChatMemberCultivate/SaveMemberCultivate`, params, { timeout: 60000 });
};

// jsdk
export const OAuth_jssdk = params => {
  return axios.get(`${base}/OAuth/jssdk/jssdk`, {
    params: params
  });
};


// 用户扫码签到保存
export const WeChatCurriculum_MemberScanCodeSignIn = params => {
    return axios.post(`${base}/api/WeChatCurriculum/MemberScanCodeSignIn`, params);
  };


  // 获取省市区
export const WeChatMember_GetStoreArea = params => {
    return axios.post(`${base}/api/WeChatMember/GetStoreArea`, params);
  };

    // 获取店招名称下拉框
export const WeChatMember_GetStoreAccount = params => {
    return axios.post(`${base}/api/WeChatMember/GetStoreAccount`, params);
  };

    // 获取门店下拉框
export const WeChatMember_GetStore = params => {
    return axios.post(`${base}/api/WeChatMember/GetStore`, params);
  };

// 检查课程解锁状态
export const WeChatCurriculumUnlock_CheckUnlockStatus = params => {
  return axios.get(`${base}/api/WeChatCurriculumUnlock/CheckUnlockStatus`, {
    params: params
  });
};

// 批量检查课程解锁状态
export const WeChatCurriculumUnlock_BatchCheckUnlockStatus = (params, openId) => {
  return axios.post(`${base}/api/WeChatCurriculumUnlock/BatchCheckUnlockStatus?openId=${openId}`, params);
};

// 获取Banner列表(移动端)
export const WeChatBanner_GetBannerList = params => {
  return axios.post(`${base}/api/WeChatBanner/GetBannerList`, params);
};

// 获取平台指引(移动端)
export const WeChatPlatformGuide_GetPlatformGuide = params => {
  return axios.get(`${base}/api/WeChatPlatformGuide/GetPlatformGuide`, params);
};

// 证书物流-提交收货地址
export const WeChatCertificateDelivery_SubmitAddress = params => {
  return axios.post(`${base}/api/WeChatCertificateDelivery/SubmitAddress`, params);
};

// 证书物流-获取物流详情
export const WeChatCertificateDelivery_GetDetail = params => {
  return axios.get(`${base}/api/WeChatCertificateDelivery/GetDetail`, {
    params: params
  });
};

// 课程投票（点赞/点踩）
export const WeChatCurriculumVote_Vote = params => {
  return axios.post(`${base}/api/WeChatCurriculumVote/Vote`, params);
};

// 意见反馈-提交
export const Feedback_Submit = params => {
  return axios.post(`${base}/api/WeChatFeedback/Submit`, params);
};



// WEBPACK FOOTER //
// ./src/api/api.js